import { formatDistanceToNow, isDate, isValid } from 'date-fns';

import { formatShortDate } from 'src/utils/formatDate';

import { Tooltip } from './Tooltip';

export function TimeSinceNow(props: { date?: Date | number | string | null }) {
  if (!props.date) {
    return <span>-</span>;
  }
  const date = new Date(props.date);

  if (!isDate(date) || !isValid(date)) {
    console.warn('Invalid date provided to TimeSinceNow:', date);
    return <span>-</span>;
  }
  const timeSinceNowText = formatDistanceToNow(date, { addSuffix: true });

  return (
    <Tooltip
      asChild
      title={formatShortDate(date, {
        showTime: true,
        showYear: true,
      })}
    >
      <span>{timeSinceNowText}</span>
    </Tooltip>
  );
}
